module.exports = {
    isProduction: true,
    api: {
        base: 'https://hfsfd-be.haofenshu.com',
        captcha: 'https://hfs2-avatar.yunxiao.com',
        slideCaptcha: 'https://hfsfd3-captcha.haofenshu.com',
        timeout: 200000
    },
    hfsStoreApi: 'https://fd-store-serv-wan.haofenshu.com',
    ssoApi: {
        base: 'http://sso.yunxiao.com',
        timeout: 200000
    },
    teacherApi: {
        base: 'http://fudaojs.haofenshu.com'
    },
    appTeacherApi: {
        base: 'https://hfsfd-teacher.haofenshu.com'
    },
    imgService: {
        prefix: 'hfsfd'
    },
    cookie: {
        key: 'hfsfd-session-id',
        domain: '.haofenshu.com'
    },
    domain: 'https://fudao.haofenshu.com',
    CmbcUrl: 'https://pay.creditcard.cmbc.com.cn/pay/cmbcApply/perpaidOrder',
    jiankeapp: {
        jianketiaozhuan: 'fudaotool://tool.fudao.aiyunxiao.com/start?pageType=2&timetableId=',
        iosDownload: 'https://itunes.apple.com/cn/app/id1508095015',
        androidDownload: 'https://appvm.yunxiao.com/dl/5e816951969df601c7b632c4'
    },
    trackPoint: {
        feMonitor: '//fe-monitor.iyunxiao.com', // trackPonit 配置获取地址
        projectId: '5da18b6b00000561022c2539', // 项目 ID
        baseURL: '//fe-monitor.iyunxiao.com', // 上报地址
        time: 5000, // 上报间隔
        sKey: 'FD_HFS_STUDENT_TrackPoint', // 本地 storge 缓存 key，可根据项目修改
        eventType: ['click'] // 事件类型
    },
    agreementUrl: 'https://fudaomkt.haofenshu.com'
};



// WEBPACK FOOTER //
// ./src/feConfig/production.js